export interface IConfigGlobalePortaleAdmin {
  appIp: string;
  appPort: number;
  auth_types?: string[];
  smart_component: {
    mobile: {
      apkType: string;
      iosEnabled: string;
    };
  };
}

export interface IConfigGlobalePortaleSaaS {
  appIp: string;
  appPort: number;
  auth_types?: string[];
  styles: {
    drawingTool: {
      colors: {
        selectedFeature: string;
        circleCenter: string;
        modify: string;
        defaultText: string;
      };
    };
    printTool: {
      defaultTitle: string;
      defaultDpi: number;
      defaultPageSize: string;
    };
    googleSearch: {
      iconBase64: string;
    };
  };
  api: {
    details: {
      valveSearch: {
        objects: string;
        hit_radius: number;
      };
    };
  };
  sidebarActionIds: {
    layerConfigurator: string;
    dynamicLayers: string;
    drawingTool: string;
    shapeConfigurator: string;
    bookmarks: string;
    query: string;
    valve: string;
    otdr: string;
    psa: string;
    controlli: string;
    trasmissioneAntea: string;
    checkInOut: string;
    analisiSchiacciamenti: string;
    tracing: string;
    checkInAnalysis: string;
    fiberJoints: string;
    toolFattibilita: string;
  };
  download: {
    template_dir: string;
  };
  solr: {
    core: {
      menu: string;
    };
  };
  export: {
    columnsToHide: string;
    fullId: string;
    geometryType: string;
    outerLabels: string;
    flippedCoords: string;
  };
  ldap?: {
    auth: {
      type: string;
      url: string;
      directories: string;
    };
  };
  external?: {
    portal: string;
    key: string;
  };
}
